import { SvgIcon, SvgIconProps } from '@mui/material';

export default function CertificatesMenuIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 26 25">
      <g fill="none">
        <path
          d="M23.3919 8.25391V2.25391C23.3919 1.42548 22.67 0.753906 21.7794 0.753906H2.42939C1.53884 0.753906 0.816895 1.42548 0.816895 2.25391V18.7539C0.816895 19.5823 1.53884 20.2539 2.42939 20.2539H15.3294"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.816895 5.25391H23.3919"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9731 18.7539C23.1995 18.7539 25.0044 17.075 25.0044 15.0039C25.0044 12.9328 23.1995 11.2539 20.9731 11.2539C18.7467 11.2539 16.9419 12.9328 16.9419 15.0039C16.9419 17.075 18.7467 18.7539 20.9731 18.7539Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.3917 18.002V23.254L20.9729 21.004L18.5542 23.254V18.002"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.9729 14.6289C21.1956 14.6289 21.3761 14.7968 21.3761 15.0039C21.3761 15.211 21.1956 15.3789 20.9729 15.3789C20.7503 15.3789 20.5698 15.211 20.5698 15.0039C20.5698 14.7968 20.7503 14.6289 20.9729 14.6289"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
